import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import ConfigManager from '@/config/ConfigManager.js';
import RenewalModel from '../Model/RenewalModel.js'
import dayjs from 'dayjs'; //https://day.js.org/

export default {
    apiGetRenewals: function (paramsQuery) {
        const token = Account.getToken();
        let params = {
            device_app_id: ConfigManager.getAppId(),
            bzbTime: dayjs().unix()
        }

        if (paramsQuery != null) {
            params.templateNo = paramsQuery.template_no,
            params.linkNo = paramsQuery.link_no
        }
        
        const url = ConfigManager.getApiModuleUrl() + "/tni/renewals";

        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                let arrRenewals = [];
                for (let i of res.data) {
                    // ต้อง deleteRecord = false ด้วย !!!
                    if (!i.DeleteRecord) {
                        let renewal = new RenewalModel();
                        renewal.setValue(i);
                        arrRenewals.push(renewal);
                    }
                }

                return arrRenewals;
            }));
    },
    logChannel: function (channel) {
        return new Promise((resolve, reject) => {
            let url = ConfigManager.getApiModuleUrl() + "/user/click_renewals"
            let params = {
                from: channel
            }
            let token = Account.getToken()
            BzbsApi.connectBzbsPost(url, token, params).subscribe({
                next: (res) => {
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    updateFlowTypeToTniPolicyRenewal: function (channel,paymentRef,query) {
        let url = ConfigManager.getApiModuleUrl() + "/user/update_renewal_flow"
        let params = {}

        params.paymentRef1 = paymentRef
        params.flowType = channel

        if (query) {
            params.flowType = query.type
            params.templateNo = query.template_no
            params.linkNo = query.link_no
        }

        let token = Account.getToken();
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    }
}
